import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { open } from './FileUpload'

export { open }

export default Loadable(() => import('./FileUpload'))
